<template>
  <main class="code d-flex align-items-center" v-cloak>
    <div class="w-100">
      <div class="container">
        <div class="row" style="padding-bottom: 100px !important">
          <div class="col-12">
            <div class="form-group" style="height:auto">
              <h5
                class="mb-5 mt-5 mt-md-0"
                style="font-size: 30px; font-weight:normal"
              >{{question.question}}</h5>
              <div class="pl-3 pr-3 form-group" style="position:relative">
                <div v-if="question.type !== 'select'">
                  <div v-if="question.type === 'number'">
                    <input
                      name="answer"
                      :type="question.type"
                      class="form-control"
                      id="answer"
                      :placeholder="$t('Enter your answer')"
                      v-model="answer"
                      step=".5"
                      autocomplete="off"
                      required
                    >
                    <label for="answer" class="h5">{{$t('Rispondi alla domanda')}}</label>
                  </div>
                  <div v-else-if="question.type === 'address'">
                    <input
                      name="answer"
                      type="text"
                      class="form-control"
                      id="answer"
                      :placeholder="$t('Enter your answer')"
                      v-gaddress
                      v-model="answer"
                      autocomplete="off"
                      required
                    >
                    <label for="answer" class="h5">{{$t('Rispondi alla domanda')}}</label>
                  </div>
                  <div v-else-if="question.type === 'city'">
                    <input
                      name="answer"
                      type="text"
                      class="form-control"
                      id="answer"
                      :placeholder="$t('Enter your answer')"
                      v-gcity
                      v-model="answer"
                      autocomplete="off"
                      required
                    >
                    <label for="answer" class="h5">{{$t('Rispondi alla domanda')}}</label>
                  </div>
                  <div v-else-if="question.type === 'birthday'">
                    <input
                      name="answer"
                      :type="question.type"
                      class="form-control form-date"
                      id="answer"
                      :placeholder="$t('Enter your answer')"
                      autocomplete="off"
                      v-model.trim="answer"
                      required
                    >
                    <label for="answer" class="h5">{{$t('Rispondi alla domanda')}}</label>
                  </div>
                  <div v-else>
                    <input
                      name="answer"
                      :type="question.type"
                      class="form-control"
                      id="answer"
                      :placeholder="$t('Enter your answer')"
                      autocomplete="off"
                      v-model.trim="answer"
                      required
                    >
                    <label for="answer" class="h5">{{$t('Rispondi alla domanda')}}</label>
                  </div>
                </div>
                <div v-else style="padding-bottom: 100px">
                  <div v-for="option in question.options" v-bind:key="option.k">
                    <button
                      class="btn btn-outline-primary btn-lg btn-block"
                      name="answer"
                      style="font-size: 20px; font-weight:normal"
                      @click="answer = option.k; saveAnswer()"
                    >{{option.v}}</button>
                  </div>
                </div>
              </div>
              <div class="text-right pr-3 mt-5">
                <div v-if="question.type !== 'select'" style="margin-top: 60px">
                  <button
                    @click="saveAnswer()"
                    class="btn btn-primary"
                  >{{$t('Rispondi')}}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import _ from "lodash";
export default {
  name: "question",
  data() {
    return {
      question: {},
      answer: ""
    };
  },
  created() {
    this.getQuestion();
  },
  methods: {
    async getQuestion() {
      this.$store.commit("showSpinner");
      try {
        let response = await this.$http.get(
          "/api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/questions/" +
            this.$route.params.questionId
        );

        this.question = _.get(response, "data.data.question");
      } catch {
        this.$store.commit("pushMessage", {
          type: "waiting",
          title: "Something went wrong",
          text: "Please retry"
        });
      }
      this.$store.commit("hideSpinner");
    },
    async saveAnswer() {
      this.$store.commit("showSpinner");
      try {
        let response = await this.$http.post(
          "/api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/questions/" +
            this.$route.params.questionId,
          {
            answer : this.answer
          }
        );
        this.$router.push("/");
        this.$store.dispatch("getUserTasks");
      } catch(error) {
          console.log(error)
        this.$store.commit("pushMessage", {
          type: "waiting",
          title: "Something went wrong",
          text: "Please retry"
        });
      }
      this.$store.commit("hideSpinner");
    }
  }
};
</script>
<style scoped>
.invalid-feedback-date {
  display: none;
}
body {
  position: relative;
}
body::after {
  content: "";
  opacity: 0.5;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  z-index: -1;
  height: 100%;
  width: 100%;
  z-index: -1;
  background-size: cover;
}
nav.navbar {
  background-color: transparent !important;
}
.form-group > div.hint {
  position: absolute;
  display: none;
  width: 100%;
  padding: 0.375rem 0;
  font-size: 14px;
  line-height: 1.6;
  color: #a8a8a9;
  font-weight: bold;
  background-color: transparent;
  background-image: none;
  background-clip: padding-box;
  border: none;
  top: 0;
  left: 0;
  -webkit-transition: border-color ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
  z-index: 1;
}
</style>
